import type { FetchRequestArgs } from '../../utils';
import { fetchRequest } from '../../utils';
import { HTTPMethod } from '../httpMethods';

export const duplicateCampaign = async <T extends Record<string, unknown>>({
  campaignId,
  boardIDs,
  campaignName,
  headers,
  domain,
  query,
}: FetchRequestArgs & {
  boardIDs: string[];
  campaignId: string;
  campaignName: string;
}): Promise<ReturnType<typeof fetchRequest>> =>
  fetchRequest<T>({
    data: { boardIDs, campaignName },
    domain,
    endpoint: `/v1/campaigns/${campaignId}/duplicate`,
    headers,
    method: HTTPMethod.POST,
    query,
  });
